var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.5,
    r: 21,
    fill: "#E4F2F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_20133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 31,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 31,
    height: 31,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_20133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4993 21.5C19.0785 21.5 17.8622 20.9941 16.8504 19.9823C15.8386 18.9705 15.3327 17.7542 15.3327 16.3334C15.3327 14.9125 15.8386 13.6962 16.8504 12.6844C17.8622 11.6726 19.0785 11.1667 20.4993 11.1667C21.9202 11.1667 23.1365 11.6726 24.1483 12.6844C25.1601 13.6962 25.666 14.9125 25.666 16.3334C25.666 17.7542 25.1601 18.9705 24.1483 19.9823C23.1365 20.9941 21.9202 21.5 20.4993 21.5ZM10.166 31.8334V28.2167C10.166 27.4847 10.3546 26.8118 10.7318 26.1978C11.1081 25.5847 11.6084 25.1167 12.2327 24.7938C13.5674 24.1264 14.9237 23.6257 16.3014 23.2916C17.6792 22.9583 19.0785 22.7917 20.4993 22.7917C21.9202 22.7917 23.3195 22.9583 24.6973 23.2916C26.075 23.6257 27.4313 24.1264 28.766 24.7938C29.3903 25.1167 29.8906 25.5847 30.2669 26.1978C30.6441 26.8118 30.8327 27.4847 30.8327 28.2167V31.8334H10.166Z",
    fill: "#04B7B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.ebf2a6e88dbcb28f6d458432d1e343bf.svg";
export { ForwardRef as ReactComponent };